import { useEffect, useState } from "react";
import SvgIcn from "../../data/IconCompo";
import PropTypes from "prop-types";
import countries from "../../data/countries.json";
import CountryFlag from "../../data/IconCountry";
import UserCard from "./UserCard";
import { getUserDetails } from "../../services/UserService";

const UserCardPopup = ({ userData, onClose }) => {
  const socialLinks = {};
  userData?.mediaLinks?.forEach((link) => {
    socialLinks[link.type] = link.link;
  });

  const profileSocialOrder = (() => {
    const keys = [
      "figma",
      "dribbble",
      "behance",
      "linkedin",
      "x",
      "instagram",
      "facebook",
      "tiktok",
    ];
    const out = [];
    const seen = new Set();
    userData?.mediaLinks?.forEach((link) => {
      const t = String(link.type || "").toLowerCase();
      const key = t === "twitter" ? "x" : t;
      if (!keys.includes(key) || !link.link) return;
      if (seen.has(key)) return;
      seen.add(key);
      out.push(key);
    });
    return out;
  })();

  return (
    <div className="user-card-popup-overlay" onClick={onClose}>
      <div
        className="user-card-popup-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-button" onClick={onClose}>
          <SvgIcn name="close" />
        </button>
        <UserCard
          data={{
            fullName: userData.fullName,
            subRole: userData.sub_role,
            nationality: userData.nationality,
            image: userData.profile_img,
            email: userData.email,
            username: userData.username,
            intro: userData.intro,
            experience: userData.experience,
            personalSite: userData.personalSite,
            personalBlog: userData.personalBlog,
            figma: socialLinks.figma,
            twitter: socialLinks.x,
            dribbble: socialLinks.dribbble,
            behance: socialLinks.behance,
            linkedin: socialLinks.linkedin,
            instagram: socialLinks.instagram,
            facebook: socialLinks.facebook,
            tiktok: socialLinks.tiktok,
          }}
          visibleInputs={{
            figma: true,
            twitter: true,
            dribbble: true,
            behance: true,
            linkedin: true,
            instagram: true,
            facebook: true,
            tiktok: true,
          }}
          socialOrder={profileSocialOrder}
          admin={true}
        />
      </div>
    </div>
  );
};

const DashboardUserCell = ({
  uxerIcon,
  locationImage,
  image,
  name,
  username,
  role,
  favs,
  clicks,
  joinedDate,
  lastAccess,
  onMessageClick,
  onDeleteClick,
  userId,
  nationality,
  user,
}) => {
  const [imgError, setImgError] = useState(false);
  const [showUserCard, setShowUserCard] = useState(false);
  const [country, setCountry] = useState();
  const [userData, setUserData] = useState(null);

  const handleIconClick = async () => {
    try {
      const data = await getUserDetails(userId);
      setUserData(data.myUser);
      setShowUserCard(true);
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    setCountry(countries.find((el) => el.value === nationality));
  }, [nationality]);
  const handleUsernameClick = () => {
    window.open(`/${username}`, "_blank");
  };

  return (
    <>
      <div className="user-row">

        <div className="user-cell user" onClick={handleIconClick}>
          <SvgIcn name={uxerIcon || "click"} />
        </div>

        <div className="user-cell loc">
          <CountryFlag Name={country?.iso2.toLowerCase()} className="flag" />
        </div>

        <div className="user-cell photo">
          {imgError && <SvgIcn name="user_2" />}
          {!imgError && (
            <img
              src={image}
              alt="User"
              onError={() => {
                setImgError(true);
              }}
            />
          )}
        </div>

        <div className="user-cell">{name}</div>

        <div
          className="user-cell username"
          onClick={handleUsernameClick}
        >
          {username}
        </div>

        <div className="user-cell">{role}</div>
        <div className="user-cell favs">{favs}</div>
        <div className="user-cell  clicks">{clicks}</div>
        <div className="user-cell joined">{joinedDate}</div>
        <div className="user-cell access">{lastAccess}</div>
        <div className="user-cell actions">
          <button onClick={() => {}}>
            <SvgIcn name="trash" />
          </button>
        </div>
      </div>

      {showUserCard && userData && (
        <UserCardPopup
          userData={userData}
          onClose={() => setShowUserCard(false)}
        />
      )}
    </>
  );
};

DashboardUserCell.propTypes = {
  uxerIcon: PropTypes.string,
  locationImage: PropTypes.string,
  image: PropTypes.string,
  name: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  favs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  clicks: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  joinedDate: PropTypes.string.isRequired,
  lastAccess: PropTypes.string.isRequired,
  onMessageClick: PropTypes.func,
  onDeleteClick: PropTypes.func.isRequired,
  userId: PropTypes.string,
  nationality: PropTypes.string,
};

export default DashboardUserCell;
